// extracted by mini-css-extract-plugin
export default {"reportsDropdown":"styles_reports-dropdown__ZksUn","reportsDropdownContent":"styles_reports-dropdown-content__SKPIZ","reportsDropdownItem":"styles_reports-dropdown-item__U4TLy"};